import { GetterTree } from "vuex";
import { IHeaderState } from "@/store/modules/header/interface";
import { IStoreRootState } from "@/store/interface";

export default <GetterTree<IHeaderState, IStoreRootState>> {

	mainButtonClickedKey: ({ mainButtonClickedKey }) => mainButtonClickedKey,

	mainButtonVisibility: ({ mainButtonVisibility }) => mainButtonVisibility

}